import { setIn } from 'icepick';
import {
	type Action as DragAction,
	DRAG_START,
	DRAG_END,
	BEFORE_CAPTURE,
	TRANSITION_ZONE_ENTER,
	TRANSITION_ZONE_LEAVE,
} from '../../../actions/drag/index.tsx';
import type { DragState } from './types.tsx';

const initialState = {
	isDragging: false,
	isSubtask: false,
	isOverTransitionZone: false,
	sourceCardGroupType: '',
	sourceCardListId: '',
	sourceParentId: undefined,
} as const;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: DragState = initialState, action: DragAction): DragState => {
	switch (action.type) {
		case DRAG_START:
			return setIn(state, ['isDragging'], true);
		case DRAG_END:
			return setIn(state, ['isDragging'], false);
		case TRANSITION_ZONE_ENTER:
			return setIn(state, ['isOverTransitionZone'], true);
		case TRANSITION_ZONE_LEAVE:
			return setIn(state, ['isOverTransitionZone'], false);
		case BEFORE_CAPTURE: {
			return {
				...state,
				sourceCardGroupType: action.payload.sourceCardGroupType,
				sourceCardListId: action.payload.sourceCardListId,
				isSubtask: action.payload.isSubtask,
				sourceParentId: action.payload.sourceParentId,
			};
		}
		default:
			return state;
	}
};
